module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', [_c('template', {
    slot: "header"
  }, [_vm._v("\n          Tee tarjous : \n          "), (!_vm.loading) ? [_vm._v("\n            " + _vm._s(_vm.$store.state.quote.current.quoteName) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('template', {
    slot: "right-col"
  })], 2)], 1), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-form-group-input', {
    attrs: {
      "component": "textarea",
      "name": "message",
      "source": "offer"
    }
  }, [_vm._v("\n          Viesti tilaajalle\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-deep-magenta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateOffer($event)
      }
    }
  }, [_vm._v("Lähetä tarjous")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6d0c1957"}!./src/app/pages/make-offer/make-offer.html
// module id = 486
// module chunks = 1